import React from 'react';
import './HeroHome.css';
import { IconPro, IconHomeCalcularCarga, IconHomePrecioFinal } from '../Icons';
import { IconHomeExporterTest } from '../Icons';
import IconHomeVerificarCumplimiento from '../../assets/images/compliance.svg';
import IconHomeVerificarLimitesResiduos from '../../assets/images/verificar-residuos.svg';
import IconPrecioFob from '../../assets/images/precio-fob.svg';
import IconFeriasEuropeas from '../../assets/images/ferias-europeas.svg';
import IconCompararPrecios from '../../assets/images/comparar-precios.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroHome: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="hero-home">
			<span className="hero-home__title">{t('hero_home.title')}</span>

			<div className="hero-home__content">
				<span className="hero-home__content__subtitle">{t('hero_home.preparation_and_compliance')}</span>
				<div className="hero-home__content__row__container">
					<div className="hero-home__content__row">
						<Link
							to="/exportertest"
							className="hero-home__item">
							<div className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.test_exportador')}</span>
								<span className="hero-home__item__description">{t('hero_home.test_exportador_description')}</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag">{t('hero_home.basic')}</span>
									{/* <span className="hero-home__item__tag hero-home__item__tag--demo">Demo</span>
                        <span className="hero-home__item__tag hero-home__item__tag--proximamente">PROXIMAMENTE</span>
                        <span className="hero-home__item__tag hero-home__item__tag--pro"><IconPro fill="#1A2228" width={15} height={12} /> PRO  </span> */}
								</div>
							</div>
							<div className="hero-home__item__icon">
								<IconHomeExporterTest />
							</div>
						</Link>

						<Link
							to="https://compliance.exportopia.eu/"
							className="hero-home__item"
							target="_blank">
							<div className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.verify_compliance')}</span>
								<span className="hero-home__item__description">{t('hero_home.verify_compliance_description')}</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag hero-home__item__tag--demo">{t('hero_home.demo')}</span>
									{/* <span className="hero-home__item__tag hero-home__item__tag--demo">{t('hero_home.demo')}</span>
									<span className="hero-home__item__tag hero-home__item__tag--pro">
										<IconPro
											fill="#1A2228"
											width={15}
											height={12}
										/>{' '}
										{t('hero_home.pro')}{' '}
									</span>
									<span className="hero-home__item__tag hero-home__item__tag--proximamente">
										{t('hero_home.coming_soon')}
									</span>
										*/}
								</div>
							</div>
							<div className="hero-home__item__icon">
								<img
									src={IconHomeVerificarCumplimiento}
									alt="Verificar cumplimiento"
									width={90}
								/>
							</div>
						</Link>
						<div className="hero-home__item">
							<div className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.verify_waste_limits')}</span>
								<span className="hero-home__item__description">{t('hero_home.verify_waste_limits_description')}</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag hero-home__item__tag--proximamente">
										{t('hero_home.coming_soon')}
									</span>
								</div>
							</div>
							<div className="hero-home__item__icon">
								<img
									src={IconHomeVerificarLimitesResiduos}
									alt="Verificar límites de residuos"
									width={90}
								/>
							</div>
						</div>
					</div>
				</div>
				<span className="hero-home__content__subtitle">{t('hero_home.costs_and_prices')}</span>
				<div className="hero-home__content__row__container">
					<div className="hero-home__content__row">
						<Link
							to="/cubicaje"
							className="hero-home__item hero-home__item--costos">
							<div className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.calculate_load_and_packaging')}</span>
								<span className="hero-home__item__description">
									{t('hero_home.calculate_load_and_packaging_description')}
								</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag">Basic</span>
									{/* <span className="hero-home__item__tag hero-home__item__tag--demo">Demo</span>
                        <span className="hero-home__item__tag hero-home__item__tag--proximamente">PROXIMAMENTE</span>
                        <span className="hero-home__item__tag hero-home__item__tag--pro"><IconPro fill="#1A2228" width={15} height={12} /> PRO  </span> */}
								</div>
							</div>
							<div className="hero-home__item__icon">
								<IconHomeCalcularCarga width={90} />
							</div>
						</Link>
						<div className="hero-home__item hero-home__item--costos">
							<div className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.calculate_price_fob')}</span>
								<span className="hero-home__item__description">{t('hero_home.calculate_price_fob_description')}</span>
								<div className="hero-home__item__tags">
									{/* <span className="hero-home__item__tag">Basic</span> */}
									<span className="hero-home__item__tag hero-home__item__tag--proximamente">
										{t('hero_home.coming_soon')}
									</span>
								</div>
							</div>
							<div className="hero-home__item__icon">
								<img
									src={IconPrecioFob}
									alt="Precio FOB"
									width={90}
								/>
							</div>
						</div>
						<div className="hero-home__item hero-home__item--costos">
							<Link
								to="/calcularprecios"
								className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.calculate_final_price')}</span>
								<span className="hero-home__item__description">{t('hero_home.calculate_final_price_description')}</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag">{t('hero_home.basic')}</span>
									<span className="hero-home__item__tag hero-home__item__tag--pro">
										<IconPro
											fill="#1A2228"
											width={15}
											height={12}
										/>{' '}
										{t('hero_home.pro')}{' '}
									</span>
								</div>
							</Link>
							<div className="hero-home__item__icon">
								<IconHomePrecioFinal width={90} />
							</div>
						</div>
					</div>
				</div>
				<span className="hero-home__content__subtitle">{t('hero_home.markets_expansion')}</span>
				<div className="hero-home__content__row__container">
					<div className="hero-home__content__row">
						<div className="hero-home__item hero-home__item--mercados">
							<div className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.european_fairs')}</span>
								<span className="hero-home__item__description">{t('hero_home.european_fairs_description')}</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag hero-home__item__tag--proximamente">
										{t('hero_home.coming_soon')}
									</span>
									{/* <span className="hero-home__item__tag hero-home__item__tag--demo">Demo</span>
                        <span className="hero-home__item__tag hero-home__item__tag--proximamente">PROXIMAMENTE</span>
                        <span className="hero-home__item__tag hero-home__item__tag--pro"><IconPro fill="#1A2228" width={15} height={12} /> PRO  </span> */}
								</div>
							</div>
							<div className="hero-home__item__icon">
								<img
									src={IconFeriasEuropeas}
									alt="Ferias europeas"
									width={80}
								/>
							</div>
						</div>
						<div className="hero-home__item hero-home__item--mercados">
							<Link
								to="/pricecomparator"
								className="hero-home__item__content">
								<span className="hero-home__item__title">{t('hero_home.compare_prices')}</span>
								<span className="hero-home__item__description">{t('hero_home.compare_prices_description')}</span>
								<div className="hero-home__item__tags">
									<span className="hero-home__item__tag hero-home__item__tag--demo">{t('hero_home.demo')}</span>
									<span className="hero-home__item__tag hero-home__item__tag--pro">
										<IconPro
											fill="#1A2228"
											width={15}
											height={12}
										/>{' '}
										PRO{' '}
									</span>
								</div>
							</Link>
							<div className="hero-home__item__icon">
								<img
									src={IconCompararPrecios}
									alt="Comparar precios"
									width={90}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeroHome;
